import { getFormValues } from 'redux-form';
import { qs } from 'url-parse';

import { INQUIRY_TEMPLATE_EDITOR_FORM_NAME } from 'dashboard/apps/InquiryTemplateEditor/InquiryTemplateEditor/constants';
import { InquiryTemplateEditorFormData } from 'dashboard/apps/InquiryTemplateEditor/InquiryTemplateEditor/types';
import SessionClientDashboard from 'dashboard/lib/clients/SessionClientDashboard';
import {
  InquiryTemplateModule,
  InquiryTemplateModuleOption,
  ModuleOptionKey,
  ModulePreview,
} from 'dashboard/models/inquiry-template-module';
import {
  setInquiryTemplateModuleOptions,
  setInquiryTemplateModulePreview,
} from 'dashboard/redux/slices/inquiry-template-modules';
import { DashboardThunkAction } from 'dashboard/redux/types';
import { FieldSchema } from 'lib/fields';
import { ApiEndpoint, ApiModel } from 'lib/interfaces/api';

export const loadInquiryTemplateModuleOptions = (): DashboardThunkAction => async (dispatch) => {
  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
  const { options: moduleOptions }: { options: InquiryTemplateModuleOption[] } = (
    await SessionClientDashboard.getResourceMeta<{ options: InquiryTemplateModuleOption[] }>(
      ApiEndpoint.InquiryTemplateModule,
      'options',
    )
  ).meta;
  dispatch(setInquiryTemplateModuleOptions({ moduleOptions }));
};

export const loadInquiryTemplateModulePreview =
  (moduleKey: ModuleOptionKey, inquiryTemplateVersionId?: string): DashboardThunkAction =>
  async (dispatch, getState) => {
    const form = getFormValues(INQUIRY_TEMPLATE_EDITOR_FORM_NAME)(
      getState(),
    ) as InquiryTemplateEditorFormData;
    /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
    const { steps, counts } = (
      await SessionClientDashboard.getResourceMeta<ModulePreview>(
        ApiEndpoint.InquiryTemplateModule,
        `${moduleKey}/preview?${qs.stringify({
          'inquiry-template-version-id': inquiryTemplateVersionId,
          'no-itv-theme': true,
          'theme-set-id': form.themeSetId,
        })}`,
      )
    ).meta;
    dispatch(setInquiryTemplateModulePreview({ key: moduleKey, steps, counts }));
  };

export const loadInquiryTemplateModule =
  (
    moduleKey: ModuleOptionKey,
    fieldSchemas: FieldSchema[],
    inquiryTemplateVersionId?: string,
  ): DashboardThunkAction<Promise<InquiryTemplateModule>> =>
  async (_, getState) => {
    const form = getFormValues(INQUIRY_TEMPLATE_EDITOR_FORM_NAME)(
      getState(),
    ) as InquiryTemplateEditorFormData;
    const meta = {
      'field-schema': fieldSchemas.map((schema) => ({
        // We intentionally do not pass the Field's config attribute b/c the server will never use it when computing
        // the fields for the module and when the client integrates the final list of fields for the modules it also
        // will never use the config attribute on any fields if there is already a "key" that exists in the client's
        // current field schema.
        key: schema.key,
        label: schema.label,
        type: schema.type,
      })),
      'inquiry-template-version-id': inquiryTemplateVersionId,
      'no-itv-theme': true,
      'theme-set-id': form.themeSetId,
    };
    const { data: inquiryTemplateModule } =
      await SessionClientDashboard.postResourceAction<InquiryTemplateModule>(
        {
          id: moduleKey,
          type: ApiModel.InquiryTemplateModule,
        },
        'generate',
        {
          /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
          meta,
        },
      );
    return inquiryTemplateModule;
  };
